import { Dispatch } from '@lumapps/redux/types';

import { actions as widgetActions } from '../slice';
import { WidgetState } from '../type';

export const filterByMetadata = (mainWidget: WidgetState, metadata: string) => async (dispatch: Dispatch) => {
    await dispatch(widgetActions.setWidgetFiltersMetadata({ widgetId: mainWidget.widgetId, metadata }));
};
